import { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Colorcontext } from '../../Component/Colorcontext/ColorContext';
import img from '../../Images/analyticsdashbordimage.png'
import img2 from '../../Images/Vector (26).png'
import img3 from '../../Images/Vector (27).png'
import { NavLink, useNavigate } from 'react-router-dom'
import user from '../../Images/user.png'
import { fetchAnalyticsBasicDetails, fetchAnalyticsFollowers, fetchAnalyticsProfileReport, fetchAnalyticsReportOverview } from '../../Redux/Slice/AnalyticsSlice';
import StarRatings from 'react-star-ratings';
import { formatDateAgo } from '../../utils/Helper';
import { SetDisplayUserData } from '../../Redux/Slice/PostSlice';
import defaultUserImage from '../../Images/logootherblm.png'
import HttpClient from '../../utils/HttpClient';

const AnalyticsProfile = () => {
    const { UserProfileID } = useSelector((state) => state.app);
    const { AnalyticsBasicDetails, AnalyticsProfileReport, AnalyticsReportOverview } = useSelector((state) => state.analytics);
    const colordata = useContext(Colorcontext);
    const [filteredFollowers, setFilteredFollowers] = useState(AnalyticsProfileReport.allFollowersData || [])
    const [filteredLikedData, setFilteredLikedData] = useState(AnalyticsReportOverview.ProfileLikedData || [])
    const [durationFilterType, setDurationFilterType] = useState("all")
    const dispatch = useDispatch()

    useEffect(() => {
        colordata.setcolor(true);
        return () => {
            colordata.setcolor(false);
        };
    }, []);

    const [UserMemberData, setUserMemberData] = useState({});
    const getUserProfile = async () => {
        const res = await HttpClient.requestData("get-profile", "GET", {});
        if (res && res?.status) {
            setUserMemberData(res?.data);
        }
    };

    const [connections, setConnections] = useState([]);
    const fetchConnections = async () => {
        const res = await HttpClient.requestData("member-contacts", "GET", {});
        if (res && res?.status) {
            setConnections(res?.data.length || 0);
        }
    };

    useEffect(() => {
        dispatch(fetchAnalyticsBasicDetails())
        dispatch(fetchAnalyticsFollowers())
        dispatch(fetchAnalyticsProfileReport())
        dispatch(fetchAnalyticsReportOverview())
        getUserProfile()
        fetchConnections()
    }, [])

    useEffect(() => {
        setFilteredFollowers(AnalyticsProfileReport.allFollowersData)
    }, [AnalyticsProfileReport.allFollowersData])

    useEffect(() => {
        setFilteredLikedData(AnalyticsReportOverview.ProfileLikedData)
    }, [AnalyticsReportOverview.ProfileLikedData])

    useEffect(() => {
        const today = new Date();
        if (durationFilterType === "today") {
            // Format today's date to YYYY-MM-DD
            const todayString = today.toISOString().split("T")[0];
            setFilteredFollowers(
                [...AnalyticsProfileReport.allFollowersData]
                    .filter((item) => {
                        // Extract only the date part from createdOn
                        const createdDate = item.createdOn.split("T")[0];
                        return createdDate === todayString;
                    })
            )
        } else if (durationFilterType === "week") {
            // Get the first day of the current week (Sunday)
            const startOfWeek = new Date(today);
            startOfWeek.setDate(today.getDate() - today.getDay());
            startOfWeek.setHours(0, 0, 0, 0); // Set to start of the day

            // Get the last day of the current week (Saturday)
            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 6);
            endOfWeek.setHours(23, 59, 59, 999); // Set to end of the day

            setFilteredFollowers(
                [...AnalyticsProfileReport.allFollowersData]
                    .filter((item) => {
                        const createdDate = new Date(item.createdOn);
                        return createdDate >= startOfWeek && createdDate <= endOfWeek;
                    })
                // .slice(0, itemsToShow)
            )
        } else if (durationFilterType === "month") {
            const currentMonth = today.getMonth(); // 0-based index (0 = January)
            const currentYear = today.getFullYear();

            setFilteredFollowers(
                [...AnalyticsProfileReport.allFollowersData]
                    .filter((item) => {
                        const createdDate = new Date(item.createdOn);
                        return (
                            createdDate.getMonth() === currentMonth && createdDate.getFullYear() === currentYear
                        );
                    })
            )
        } else {
            setFilteredFollowers(
                [...AnalyticsProfileReport.allFollowersData]
            )
        }

    }, [durationFilterType])

    const navigate = useNavigate()
    const [singleData, setSingleData] = useState()

    const handleBusinessPageView = (e, item) => {
        e.preventDefault()
        setSingleData(item)
        dispatch(SetDisplayUserData([item]))
        if (item?.businessStatus) {
            { item?.companySlug && (navigate(`/businesspage/${item?.companySlug}`)) }
        } else {
            { item?.userName && (navigate(`/profile/${item?.userName}`)) }
        }
    }

    const handleProfilePageView = (e, item) => {
        e.preventDefault()
        navigate(`/profile/${item?.userName}`)
    }

    const [visitorsData, setVisitorsData] = useState(filteredFollowers)

    useEffect(() => {
        setVisitorsData(filteredFollowers.filter(item => item?.visitedBy !== UserProfileID?._id))
    }, [filteredFollowers])

    return (
        <>
            <section className='membermastersection' style={{
                padding: '10px 0px'
            }}>
                <div className="cust_container">
                    <div className='membermastersectionbg member_section_new_class' style={{

                        background: 'transparent',
                    }}>
                        <div className='left_analtics_div_wrapper'>
                            <div className='left_analtics_container'>
                                <div className='left_analtics_logo'>
                                    <div className='analytics_img_div'>
                                        <img src={img} />

                                    </div>
                                    <p>Analytics</p>
                                </div>
                                <div className='nav_link_wrapper'>
                                    <NavLink to={'/analytics-report'} className='left_analtics_links_wrapper'>
                                        <div className='left_analtics_link_img'>
                                            <img src={img2} />
                                        </div>
                                        <p>Overview</p>
                                    </NavLink>
                                    {
                                        UserProfileID?.businessStatus &&
                                        <NavLink to={'/analytics'} className='left_analtics_links_wrapper'>
                                            <div className='left_analtics_link_img'>
                                                <img src={img3} />
                                            </div>
                                            <p>My Page</p>
                                        </NavLink>
                                    }

                                    <NavLink to={'/analytics-profile'} className='left_analtics_links_wrapper'>
                                        <div className='left_analtics_link_img'>
                                            <img src={img3} />
                                        </div>
                                        <p>My Profile</p>
                                    </NavLink>
                                </div>
                                {/* <div className='nav_link_wrapper'>
                                    <div onClick={(() => setdropdown(!dropdown))} className='left_analtics_links_wrapper'>
                                        <div className='left_analtics_link_img'>
                                            <img src={img3} />
                                        </div>
                                        <p>BLM page</p>

                                        <img src={arrowup} style={{
                                            width: '22px',
                                            height: '22px',
                                            marginTop: '7px'
                                        }} />
                                    </div>
                                    {dropdown && <div className='blm_page_dropdown_div'>
                                        <p>Followers</p>
                                        <p>Public</p>
                                    </div>}

                                    <div onClick={(() => setdropdown2(!dropdown2))} className='left_analtics_links_wrapper'>
                                        <div className='left_analtics_link_img'>
                                            <img src={img3} />
                                        </div>
                                        <p>Profile</p>

                                        <img src={arrowup} style={{
                                            width: '22px',
                                            height: '22px',
                                            marginTop: '7px'
                                        }} />
                                    </div>

                                    {dropdown2 && <div className='blm_page_dropdown_div'>
                                        <p>Members</p>
                                        <p>Non Members</p>
                                    </div>}
                                </div> */}
                            </div>
                            {/* <div className='export_div_wrapper'>
                                <div className='export_div'>
                                    <div className='export_img'>
                                        <img src={img5} />
                                    </div>
                                    <p>Export</p>
                                </div>
                                <div className='lock_img_div'>
                                    <img src={img6} />
                                </div>
                            </div> */}
                        </div>
                        <div className='right_analtics_div'>
                            <div className='right_analtics_div_container'>
                                <div className='overview_wrapper'>
                                    <p>My Profile</p>
                                    {/* {
                                        showFilter &&
                                        <div className='filter_box_wrapper'>
                                            <div className='filter_box'>
                                                <img src={img7} />
                                                <p>2</p>
                                            </div>
                                            <div className='filter_box'>
                                                <img src={img8} />
                                                <span>Jan 1, 2024 - Dec 31, 2024</span>
                                            </div>
                                        </div>
                                    } */}
                                </div>


                                <div className='right_box_wrapper'>
                                    <div className='right_box_div'>
                                        <p>Connections</p>
                                        <div className='star_wrapper2'>
                                            <span>{connections || 0}</span>

                                        </div>
                                    </div>

                                    <div className='right_box_div'>
                                        <p>Profile Views</p>
                                        <div className='star_wrapper3'>
                                            <span>{AnalyticsProfileReport?.hitsData?.length || 0}</span>

                                        </div>
                                    </div>

                                    <div className='right_box_div'>
                                        <p>Profile Likes</p>
                                        <div className='star_wrapper3'>
                                            <span>{UserMemberData?.likeCount || AnalyticsProfileReport?.TotalLikeCount || AnalyticsProfileReport?.totalProfileLikes || 0}</span>

                                        </div>
                                    </div>
                                </div>

                                <div className='right_box_wrapper'>
                                    <div className='right_box_div'>
                                        <p>Profile Rating</p>
                                        <div className='star_wrapper'>
                                            <span>{AnalyticsProfileReport?.totalProfileAvgRating?.toFixed(1)}</span>
                                            {/* <i class="fa-solid fa-star text-warning"></i>
                                            <i class="fa-solid fa-star text-warning"></i>
                                            <i class="fa-solid fa-star"></i>
                                            <i class="fa-solid fa-star"></i>
                                            <i class="fa-solid fa-star"></i> */}
                                            <StarRatings
                                                rating={AnalyticsProfileReport?.totalProfileAvgRating || 0}
                                                starRatedColor="#ffc107"
                                                starEmptyColor="#212529"
                                                numberOfStars={5}
                                                name="UserProfileRating"
                                                starDimension="22px"
                                                starSpacing="3px"
                                                className="fa-solid fa-star"
                                            />
                                        </div>

                                    </div>

                                    {/* <div className='right_box_div'>
                                        <p>Page Followers</p>
                                        <div className='star_wrapper2'>
                                            <span>{AnalyticsBasicDetails?.totalPageFollowerCount || 0}</span>
                                            <h6>
                                                <img src={arrowup2} />
                                                26%
                                            </h6>
                                        </div>
                                    </div> */}

                                    <div className='right_box_div'>
                                        <p>Profile impressions</p>
                                        <div className='star_wrapper3'>
                                            <span>{AnalyticsBasicDetails?.totalImpressionCount || 0}</span>
                                            {/* <h6>
                                                <img src={arrowdown} />
                                                4%
                                            </h6> */}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='right_analtics_table_wrapper'>
                                <div className='all_actives_wrapper'>
                                    <h2>All Activities</h2>
                                    <div className='select_boxes'>
                                        {/* <select>
                                            <option value={'blmpage'}>BLM Page</option>
                                            <option value={'profile'}>Profile</option>
                                        </select>

                                        <select>
                                            <option value={'follow'}>Follower</option>
                                            <option value={'like'}>Liker</option>
                                            <option value={'rating'}>Reviewer</option>
                                        </select> */}

                                        <select
                                            onChange={(e) => { setDurationFilterType(e.target.value) }}
                                        >
                                            <option value={'all'}>Show all</option>
                                            <option value={'today'}>Today</option>
                                            <option value={'week'}>This Week</option>
                                            <option value={'month'}>This Month</option>
                                        </select>
                                    </div>


                                </div>
                                <div className='right_table_content_wrapper'>
                                    <table>
                                        <tbody>
                                            {
                                                // filteredFollowers
                                                visitorsData
                                                    // .sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))
                                                    .map((e, i) => {

                                                        return (
                                                            <>
                                                                <tr style={{
                                                                    borderBottom: ' 1px solid rgba(195, 195, 195, 1)'
                                                                }}>
                                                                    <td className='table_data_1'>
                                                                        <div className='company_logo_details_Wrappper'
                                                                            style={{
                                                                                cursor: "pointer"
                                                                            }}
                                                                            onClick={(event) => handleBusinessPageView(event, e?.visitedByData)}
                                                                        >
                                                                            <div className='logo_img656'>
                                                                                <img src={e.visitedByData?.profilePhoto || defaultUserImage} title={e?.visitedByData?.personName} />
                                                                            </div>
                                                                            <div className='logo_details656'>
                                                                                <p>{e?.visitedByData?.personName}</p>
                                                                                <span>{e?.visitedByData?.companyName}</span>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td className='table_data_2'>
                                                                        Visited You
                                                                    </td>
                                                                    <td className='table_data_3'>
                                                                        {formatDateAgo(e?.createdOn)}
                                                                    </td>
                                                                    <td className='table_data_4'>
                                                                        <div>
                                                                            <img src={e.visitedByData?.businessProfilePic || user} style={{ maxHeight: "47px" }} />
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        )
                                                    })}

                                            {filteredLikedData
                                                // .sort((a, b) => b?.createdOn - a?.createdOn)
                                                .map((e, i) => {
                                                    return (
                                                        <>
                                                            <tr style={{
                                                                borderBottom: ' 1px solid rgba(195, 195, 195, 1)'
                                                            }}>
                                                                <td className='table_data_1'>
                                                                    <div className='company_logo_details_Wrappper'
                                                                        style={{
                                                                            cursor: "pointer"
                                                                        }}
                                                                        onClick={(event) => handleProfilePageView(event, e?.likeddByData)}
                                                                    >
                                                                        <div className='logo_img656'>
                                                                            <img src={e.likeddByData?.profilePhoto || defaultUserImage} title={e?.likeddByData?.personName} />
                                                                        </div>
                                                                        <div className='logo_details656'>
                                                                            <p>{e?.likeddByData?.personName}</p>
                                                                            <span>{e?.likeddByData?.companyName}</span>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className='table_data_2'>
                                                                    Liked your profile
                                                                </td>
                                                                <td className='table_data_3'>
                                                                    {formatDateAgo(e?.createdOn)}
                                                                </td>
                                                                <td className='table_data_4'>
                                                                    <div>
                                                                        <img src={user} />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )
                                                })}

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default AnalyticsProfile
